interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <nav aria-label="分页导航" className="flex items-center justify-center flex-wrap gap-2 mt-10">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`h-10 px-4 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
          current === 1
            ? 'text-foreground-500 border border-background-200 cursor-not-allowed'
            : 'text-foreground-800 border border-background-300 hover:border-primary-500/60 cursor-pointer'
        }`}
      >
        上一页
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          aria-current={p === current ? 'page' : undefined}
          className={`w-10 h-10 rounded-md text-sm font-medium transition-colors cursor-pointer ${
            p === current
              ? 'bg-primary-500 text-background-50'
              : 'text-foreground-700 border border-background-300 hover:border-primary-500/60'
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className={`h-10 px-4 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
          current === total
            ? 'text-foreground-500 border border-background-200 cursor-not-allowed'
            : 'text-foreground-800 border border-background-300 hover:border-primary-500/60 cursor-pointer'
        }`}
      >
        下一页
      </button>
    </nav>
  );
}